import { Button, RadioButton, Typography } from '@altify/components';
import { useProductsGraphs } from '@hooks/products/useGraphs';
import {
  useFunctionalCurrency,
  useProductsWithHoldingsAndRates,
} from '@hooks/products/useProducts';
import { AiInsightsIcon } from 'assets/icons/AiInsightsIcon';
import { parseAiInsightsQuestions } from './utils/questionParser';
import { NewChatIcon } from 'assets/icons/NewChatIcon';

interface AiInsightsQuestionsListProps {
  pageName: 'Explore' | 'Portfolio' | 'Assets';
  productType?: string;
  productCode?: string;
  onPress: (question: string) => void;
  excludedQuestion?: string;
  hasAccessToBetaFeatures?: boolean;
}

export const AiInsightsQuestionsList = ({
  pageName,
  productType,
  productCode,
  onPress,
  excludedQuestion,
  hasAccessToBetaFeatures,
}: AiInsightsQuestionsListProps) => {
  const { functionalCurrency } = useFunctionalCurrency();
  const productGraph = useProductsGraphs('24h', {
    displayCurrency: functionalCurrency?.code || 'ZAR',
  });
  const { products } = useProductsWithHoldingsAndRates();
  const aiInsightsQuestions = parseAiInsightsQuestions(
    pageName,
    products || [],
    productGraph,
    productCode,
    productType,
    hasAccessToBetaFeatures,
  );

  return (
    <div className="flex flex-col h-full w-full gap-4">
      {aiInsightsQuestions
        ?.filter(q => !excludedQuestion || q.label !== excludedQuestion)
        .map(template => {
          return  template.label === 'Start a new chat' ?
            <Button
              size="medium"
              className="px-4 py-3 bg-[#B393FF] hover:bg-transparent justify-start text-black hover:text-white transition-colors hover:border-white border"
              onPress={() => onPress(template.label)}
              fullWidth={true}
            >
              <NewChatIcon fill='black' />
              <Typography className='ml-2 mt-0.5 text-inherit text-md hover:text-white'>{template.label}</Typography>
            </Button>
             
          :
            <RadioButton
              key={template.value}
              selected={false}
              className="flex gap-2 w-full justify-start items-center px-4 py-2 min-h-10 h-auto border border-white active:bg-[#B393FF]"
              iconClassname="stroke-white"
              textClassName="text-xs"
              title={template.label}
              onPress={() => onPress(template.label)}
              size="large"
              weight="normal"
              iconComponent={AiInsightsIcon}
              iconProps={{ size: 20 }}
              ignoreHeight={true}
            />
        })}
    </div>
  );
};
